<script setup lang="ts">
import {ConversationMessageInteraction} from "@/conversation/interfaces";
import {MousePointerClick} from "@lucide/vue";
import dateHelper from "@/core/helpers/dateHelper";
import {RcsPayload} from "@/notification-template/interfaces";

defineProps<{
    interactions: ConversationMessageInteraction[];
    payload: RcsPayload;
}>();
</script>

<template>
  <div class="rounded-md bg-primary/10 border border-primary px-3 py-2">
    <div class="flex items-center gap-1.5 mb-1.5">
      <MousePointerClick class="size-3.5 text-primary" />
      <span class="font-semibold text-primary uppercase text-xs leading-tight">Interactions</span>
    </div>
    <div class="space-y-1">
      <div
        v-for="interaction in interactions"
        :key="interaction.id"
        class="flex items-center justify-between gap-3 text-xs text-muted-foreground"
      >
        <span class="font-medium text-foreground truncate">{{ interaction.text ?? interaction.action_id }}</span>
        <span class="shrink-0">{{ dateHelper.mediumFormat(interaction.created_at) }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
